import { Outlet } from "react-router-dom"
import { SearchInThisArea } from "../../common/SearchInThisArea"
import { Map } from "../../common/Map"
import { Icon } from "../../common/Icon"
import { Container, Wrapper, LayoutContainer, ModalContainer } from "./Layout.styles"
import { useLayout } from "./Layout.hooks"
import { List } from "../../views/List"
import { Search } from "../Search"
import { CategoryFilters } from "../../common/CategoryFilters"
import { MyLocation } from "../../common/MyLocation"
import { GoToDoveMed, Modal, ModalContentContainer } from "@pinkyhead/dovekit"
import { User } from "../User"
import { Results } from "../Results"
import { DataType } from "../Results/Results.interface"
import { SearchSection } from "../SearchSection"
import { FiltersChip } from "../../common/FiltersChip"
import { GoToDefaultView } from "../../common/GoToDefaultView"

export const Layout = ({ isMobile }: { isMobile: boolean }) => {
  const {
    data,
    showSearchInThisArea,
    generatePseudorandomString,
    goBackTo,
    extraMarker,
    openClaimInfoModal,
    setOpenClaimInfoModal
  } = useLayout();  
  return (
    <LayoutContainer>
      <GoToDoveMed 
        onClick={goBackTo.onClick}
        fullScreen
      >
        Go back to {goBackTo.appName}
      </GoToDoveMed>
      <MyLocation />
      <GoToDefaultView />
      <Modal 
        open={openClaimInfoModal}
        header={{
          title: "Find Your Profile",
          closeCallback: () => setOpenClaimInfoModal(false)     
        }}
        footer={{
          primaryButton: {
            children: isMobile ? "Find" : `Let's find your profile`,
            onClick: () => setOpenClaimInfoModal(false)
          }
        }}
      >
        <ModalContentContainer footer header fullScreen={false}>
          <ModalContainer>
            <p>To find your profile on the DoveMed map, simply search your location or name in the search bar. It's that easy!</p>
          </ModalContainer>
        </ModalContentContainer>
      </Modal>
      <Container>
        {isMobile
          ? 
            <>
              <SearchSection />
              <Wrapper>
                <Outlet />
                <Map>
                  {showSearchInThisArea &&
                    <SearchInThisArea />
                  }
                  {(data && data.length > 0) && data.map((each: any) => (
                    <Icon key={generatePseudorandomString(16)} data={each} isMobile={true} />
                  ))}
                </Map>
                {extraMarker &&
                  <Results type={DataType.DETAIL}>
                    <div></div>
                  </Results>
                }
                {!extraMarker &&
                  <Results type={DataType.LIST}>
                    <List />
                  </Results>
                }
              </Wrapper>
            </>
          :
            <>
              <Wrapper>
                <div className="header">
                  <Search />
                  <FiltersChip />
                </div>
                <List />
              </Wrapper>
              <div className="wrapper">
                <div className="outlet">
                  <Outlet />
                </div>
                <Map>
                  <CategoryFilters />
                  {showSearchInThisArea &&
                    <SearchInThisArea />
                  }
                  <User />
                  {(data && data.length > 0) && data.map((each: any) => (
                    <Icon key={generatePseudorandomString(16)} data={each} isMobile={false} />
                  ))}
                </Map>
              </div>
            </>
        }
      </Container>
    </LayoutContainer>
  )
}
